module.exports = __webpack_public_path__ + "static/media/loader.0d0345f6.gif";